import { Mail, CheckCircle, Clock, Calendar } from "lucide-react";

export default function PedidoColaboracao({ issue, createdAt, answered }) {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const statusConfig = {
        answered: {
            icon: <CheckCircle className="w-4 h-4 text-emerald-500" />,
            text: "Respondido",
            color: "text-emerald-600 bg-emerald-50"
        },
        pending: {
            icon: <Clock className="w-4 h-4 text-amber-500" />,
            text: "Pendente",
            color: "text-amber-600 bg-amber-50"
        }
    };

    const status = answered ? statusConfig.answered : statusConfig.pending;

    return (
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
            <div className="p-5">
                {/* Header com ícone e assunto */}
                <div className="flex items-start gap-3 mb-4">
                    <div className="flex-shrink-0">
                        <div className="w-10 h-10 rounded-full bg-emerald-50 flex items-center justify-center">
                            <Mail className="w-5 h-5 text-emerald-500" />
                        </div>
                    </div>
                    <div className="flex-1">
                        <h3 className="text-sm font-medium text-gray-800 mb-1">
                            {issue}
                        </h3>
                        <div className="flex flex-wrap items-center gap-3">
                            <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${status.color}`}>
                                {status.icon}
                                {status.text}
                            </span>
                            <div className="flex items-center gap-1.5 text-xs text-gray-400">
                                <Calendar className="w-3.5 h-3.5" />
                                <span>Submetido em: {formatDate(createdAt)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}